/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Badges_Prepurchase2Inputs */

const id_offerdetail_badges_prepurchase2 = /** @type {(inputs: Offerdetail_Badges_Prepurchase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pre-Pembelian`)
};

const ms_offerdetail_badges_prepurchase2 = /** @type {(inputs: Offerdetail_Badges_Prepurchase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pre-Pembelian`)
};

const da_offerdetail_badges_prepurchase2 = /** @type {(inputs: Offerdetail_Badges_Prepurchase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forudbestilling`)
};

const de_offerdetail_badges_prepurchase2 = /** @type {(inputs: Offerdetail_Badges_Prepurchase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorabkauf`)
};

const en_us2_offerdetail_badges_prepurchase2 = /** @type {(inputs: Offerdetail_Badges_Prepurchase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pre-Purchase`)
};

const es_es2_offerdetail_badges_prepurchase2 = /** @type {(inputs: Offerdetail_Badges_Prepurchase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reserva anticipada`)
};

const es_mx2_offerdetail_badges_prepurchase2 = /** @type {(inputs: Offerdetail_Badges_Prepurchase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pre-compra`)
};

const fil_offerdetail_badges_prepurchase2 = /** @type {(inputs: Offerdetail_Badges_Prepurchase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pre-Purchase`)
};

const fr_offerdetail_badges_prepurchase2 = /** @type {(inputs: Offerdetail_Badges_Prepurchase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pré-commande`)
};

const it_offerdetail_badges_prepurchase2 = /** @type {(inputs: Offerdetail_Badges_Prepurchase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pre-acquisto`)
};

const hu_offerdetail_badges_prepurchase2 = /** @type {(inputs: Offerdetail_Badges_Prepurchase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Előrendelés`)
};

const nl_offerdetail_badges_prepurchase2 = /** @type {(inputs: Offerdetail_Badges_Prepurchase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vooraankoop`)
};

const no_offerdetail_badges_prepurchase2 = /** @type {(inputs: Offerdetail_Badges_Prepurchase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forhåndskjøp`)
};

const pl_offerdetail_badges_prepurchase2 = /** @type {(inputs: Offerdetail_Badges_Prepurchase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przedsprzedaż`)
};

const pt_br2_offerdetail_badges_prepurchase2 = /** @type {(inputs: Offerdetail_Badges_Prepurchase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pré-compra`)
};

const pt_offerdetail_badges_prepurchase2 = /** @type {(inputs: Offerdetail_Badges_Prepurchase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pré-compra`)
};

const ro_offerdetail_badges_prepurchase2 = /** @type {(inputs: Offerdetail_Badges_Prepurchase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precomandă`)
};

const fi_offerdetail_badges_prepurchase2 = /** @type {(inputs: Offerdetail_Badges_Prepurchase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ennakko-osto`)
};

const sv_offerdetail_badges_prepurchase2 = /** @type {(inputs: Offerdetail_Badges_Prepurchase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Förköp`)
};

const vi_offerdetail_badges_prepurchase2 = /** @type {(inputs: Offerdetail_Badges_Prepurchase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đặt trước`)
};

const tr_offerdetail_badges_prepurchase2 = /** @type {(inputs: Offerdetail_Badges_Prepurchase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ön Satın Alma`)
};

const cs_offerdetail_badges_prepurchase2 = /** @type {(inputs: Offerdetail_Badges_Prepurchase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Předobjednávka`)
};

const bg_offerdetail_badges_prepurchase2 = /** @type {(inputs: Offerdetail_Badges_Prepurchase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварителна покупка`)
};

const ru_offerdetail_badges_prepurchase2 = /** @type {(inputs: Offerdetail_Badges_Prepurchase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предзаказ`)
};

const uk_offerdetail_badges_prepurchase2 = /** @type {(inputs: Offerdetail_Badges_Prepurchase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Передзамовлення`)
};

const ar_offerdetail_badges_prepurchase2 = /** @type {(inputs: Offerdetail_Badges_Prepurchase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الطلب المسبق`)
};

const hi_offerdetail_badges_prepurchase2 = /** @type {(inputs: Offerdetail_Badges_Prepurchase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्री-परचेज़`)
};

const th_offerdetail_badges_prepurchase2 = /** @type {(inputs: Offerdetail_Badges_Prepurchase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สั่งซื้อล่วงหน้า`)
};

const ja_offerdetail_badges_prepurchase2 = /** @type {(inputs: Offerdetail_Badges_Prepurchase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`予約購入`)
};

const zh_cn2_offerdetail_badges_prepurchase2 = /** @type {(inputs: Offerdetail_Badges_Prepurchase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预购`)
};

const zh_hant1_offerdetail_badges_prepurchase2 = /** @type {(inputs: Offerdetail_Badges_Prepurchase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`預購`)
};

const ko_offerdetail_badges_prepurchase2 = /** @type {(inputs: Offerdetail_Badges_Prepurchase2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`선구매`)
};

/**
* | output |
* | --- |
* | "Pre-Purchase" |
*
* @param {Offerdetail_Badges_Prepurchase2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_badges_prepurchase2 = /** @type {((inputs?: Offerdetail_Badges_Prepurchase2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Badges_Prepurchase2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_badges_prepurchase2(inputs)
	if (locale === "ms") return ms_offerdetail_badges_prepurchase2(inputs)
	if (locale === "da") return da_offerdetail_badges_prepurchase2(inputs)
	if (locale === "de") return de_offerdetail_badges_prepurchase2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_badges_prepurchase2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_badges_prepurchase2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_badges_prepurchase2(inputs)
	if (locale === "fil") return fil_offerdetail_badges_prepurchase2(inputs)
	if (locale === "fr") return fr_offerdetail_badges_prepurchase2(inputs)
	if (locale === "it") return it_offerdetail_badges_prepurchase2(inputs)
	if (locale === "hu") return hu_offerdetail_badges_prepurchase2(inputs)
	if (locale === "nl") return nl_offerdetail_badges_prepurchase2(inputs)
	if (locale === "no") return no_offerdetail_badges_prepurchase2(inputs)
	if (locale === "pl") return pl_offerdetail_badges_prepurchase2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_badges_prepurchase2(inputs)
	if (locale === "pt") return pt_offerdetail_badges_prepurchase2(inputs)
	if (locale === "ro") return ro_offerdetail_badges_prepurchase2(inputs)
	if (locale === "fi") return fi_offerdetail_badges_prepurchase2(inputs)
	if (locale === "sv") return sv_offerdetail_badges_prepurchase2(inputs)
	if (locale === "vi") return vi_offerdetail_badges_prepurchase2(inputs)
	if (locale === "tr") return tr_offerdetail_badges_prepurchase2(inputs)
	if (locale === "cs") return cs_offerdetail_badges_prepurchase2(inputs)
	if (locale === "bg") return bg_offerdetail_badges_prepurchase2(inputs)
	if (locale === "ru") return ru_offerdetail_badges_prepurchase2(inputs)
	if (locale === "uk") return uk_offerdetail_badges_prepurchase2(inputs)
	if (locale === "ar") return ar_offerdetail_badges_prepurchase2(inputs)
	if (locale === "hi") return hi_offerdetail_badges_prepurchase2(inputs)
	if (locale === "th") return th_offerdetail_badges_prepurchase2(inputs)
	if (locale === "ja") return ja_offerdetail_badges_prepurchase2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_badges_prepurchase2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_badges_prepurchase2(inputs)
	return ko_offerdetail_badges_prepurchase2(inputs)
});
export { offerdetail_badges_prepurchase2 as "offerDetail.badges.prePurchase" }